/** @format */

const template = `
<ng-form name="{{ ctrl.formName }}">
  <div class="row add-new" ng-if="ctrl.isCoordinatingOrganisationUrn() && !ctrl.showOrganisations()">
    <div class="col-md-12">
      <p class="guidance" translate>SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.COORDINATING_ORGANISATIONS_GUIDANCE</p>
      <button type="button" class="link-button" ng-click="ctrl.addCoordinatingOrganisations()">
        <sis-icon icon="ring-plus"></sis-icon
        >{{ "SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.ADD_COORDINATING_ORGANISATIONS" | translate }}
      </button>
    </div>
  </div>

  <div ng-if="ctrl.showOrganisations()" ng-repeat="validityGroup in ctrl.validityGroups track by $index" class="validity-group">
    <div class="row add-new">
      <div class="col-md-12">
        <button type="button" class="link-button" ng-click="ctrl.addNew($index)">
          <sis-icon icon="ring-plus"></sis-icon
          >{{
            "SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.ADD_" + ($first ? "EARLIER_VALIDITY_PERIOD" : "VALIDITY_PERIOD")
              | translate
          }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 organisation-role-share-row">
        <div class="grouping-panel">
          <label class="control-label" translate>SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.VALID</label
          ><!--
                    --><button
            type="button"
            ng-if="ctrl.validityGroups.length > 1"
            class="link-button"
            ng-click="ctrl.remove($index)"
            aria-label="{{ 'ARIA_LABEL.DELETE' | translate }} {{
              'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.VALID' | translate
            }}">
            <sis-icon icon="delete"></sis-icon>
          </button>
          <organisation-role-share-validity-group-editor
            form-name="validityGroupForm{{ $index }}"
            previous-validity-group="ctrl.validityGroups[$index - 1]"
            next-validity-group="ctrl.validityGroups[$index + 1]"
            organisation-service="ctrl.organisationService"
            organisation-role-shares="validityGroup.organisationRoleShares"
            organisation-role-urn="ctrl.organisationRoleUrn"
            validity-period="validityGroup.validityPeriod"
            disabled-organisation-ids="validityGroup.disabledOrganisationIds"
            on-change="ctrl.handleChange()"
            is-valid="ctrl.formsValid[$index]"
            empty-organisations-allowed="ctrl.emptyOrganisationsAllowed">
          </organisation-role-share-validity-group-editor>
        </div>
      </div>
    </div>

    <div class="row add-new" ng-if="$last">
      <div class="col-md-12">
        <button type="button" class="link-button last" ng-click="ctrl.addNew($index + 1)">
          <sis-icon icon="ring-plus"></sis-icon
          >{{ "SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.ADD_LATER_VALIDITY_PERIOD" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-form>
`;
export default template;
